import TableRow, { TableRowProps } from "@mui/material/TableRow";
import { styled } from "@mui/material/styles";
import React from "react";

interface CustomTableRowProps extends TableRowProps {
  header?: boolean;
}
export const TableRowRoot = styled(TableRow)<CustomTableRowProps>(
  ({ theme, header = false, sx }) => {
    return {
      ...(header
        ? {
            fontWeight: 700,
            ...theme.typography.caption,
            fontFamily: "SegoeBold",
          }
        : {
            fontWeight: 400,
            ...theme.typography["body-small"],
            fontFamily: "SegoeRegular",
          }),
      padding: "15px 8px",
      whiteSpace: "nowrap",
      // border: "0px !important",
      color: theme.palette.lightBg.high,
      ":hover": {
        cursor: "pointer",
      },
      // Data rows only (they render with MUI's `hover` prop; headers, empty,
      // loading and footer rows don't). Same lift as table-v2's row hover.
      // This table collapses borders, so the next row would paint over the
      // shadow; raising the hovered row keeps it visible.
      "&.MuiTableRow-hover:hover": {
        position: "relative",
        zIndex: 1,
        borderRadius: "8px",
        boxShadow: `0 0 0 1px ${theme.palette.neutral["010"]}, -4px 9px 11px 0px #00000014`,
      },
      transition: "background-color 0.2s ease",
      borderBottom: "1px solid rgb(0, 0, 0)",
      "&:nth-of-type(even)": {
        // borderBottom: "1px solid rgb(0, 0, 0)",
        backgroundColor: theme.palette.darkBg.high,
        ":hover": {
          backgroundColor: theme.palette.darkBg.high,
          // boxShadow: "0px 6px 5px 0px rgba(0, 0, 0, 0.1)",
        },
      },
      "&:nth-of-type(odd)": {
        // borderBottom: "1px solid rgb(0, 0, 0)",
        backgroundColor: theme.palette.darkBg.high,
        ":hover": {
          backgroundColor: theme.palette.darkBg.high,
          // boxShadow: "0px 6px 5px 0px rgba(0, 0, 0, 0.1)",
        },
      },
    };
  },
);
